import React, {memo} from 'react';
import {Button} from "reactstrap";
import {
    ConfirmationText,
    CongratulationsText,
    ContentWrapper,
    PaymentSuccessContainer,
    OrderStatusIcon,
    SuccessMessage,
    Title
} from "../../orderComplete.style";

const PendingIconSVG = memo(() => (
    <svg width="130" height="133" viewBox="0 0 130 133" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M62.5774 69.0053L60.039 30.7765H70.9616L68.4232 69.0053H62.5774ZM60.6544 83.543V73.6973H70.4231V83.543H60.6544Z" fill="#FAD200"/>
        <mask id="mask0_4282_6285" style={{maskType: "luminance"}} maskUnits="userSpaceOnUse" x="20" y="1" width="91" height="113">
            <path d="M27.4167 3.20956L103.25 3.20955C104.687 3.20955 106.064 3.78023 107.08 4.79605C108.096 5.81187 108.667 7.18963 108.667 8.62622L108.667 84.4595L108.667 111.543L81.5833 111.543L27.4167 111.543C25.9801 111.543 24.6023 110.972 23.5865 109.956C22.5707 108.941 22 107.563 22 106.126L22 8.62623C22 7.18964 22.5707 5.81188 23.5865 4.79606C24.6023 3.78024 25.9801 3.20956 27.4167 3.20956Z" fill="#555555" stroke="#FAD200" strokeWidth="4" stroke-linecap="round" strokeLinejoin="round"/>
        </mask>
        <g mask="url(#mask0_4282_6285)">
            <path d="M0.333496 122.375L130.333 122.375L130.333 -7.62501L0.333485 -7.625L0.333496 122.375Z" fill="#FAD200"/>
        </g>
        <circle cx="112.864" cy="111.407" r="10.083" fill="#FDF0AA"/>
        <path d="M112.917 97.543C105.235 97.543 99 103.778 99 111.46C99 119.142 105.235 125.376 112.917 125.376C120.599 125.376 126.833 119.142 126.833 111.46C126.833 103.778 120.599 97.543 112.917 97.543ZM117.509 118L111.525 112.016V103.11H114.308V110.875L119.458 116.024L117.509 118Z" fill="#FAD200"/>
    </svg>
))

const SplitBuyPaymentPending = memo(() => {
    return (
        <PaymentSuccessContainer>
            <ContentWrapper>
                <Title>Split Buy Payment</Title>
                <OrderStatusIcon>
                    <PendingIconSVG/>
                </OrderStatusIcon>

                <SuccessMessage>
                    <CongratulationsText>
                        Payment Pending! Almost There!
                    </CongratulationsText>
                    <ConfirmationText>
                        We noticed your payment is still pending for <br/>
                        joining the split-buying group.
                    </ConfirmationText>
                    <ConfirmationText>
                        No worries—Once your payment is confirmed, <br/>
                        you’ll be granted access to the group!
                    </ConfirmationText>
                </SuccessMessage>
            </ContentWrapper>
            <a href="/split-buy"  className={"mobile-sticky-checkout"}>
                <Button className={"custom-app-btn"}>
                    Re-Direct To Home
                </Button>
            </a>

        </PaymentSuccessContainer>
    );
});

export default SplitBuyPaymentPending;